import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "full-width section-medium bg-gray-light mb-5" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "showcase-app__filtering row" }
const _hoisted_4 = { class: "showcase-app__filtering-col col-md-12 col-lg-2" }
const _hoisted_5 = { class: "showcase-app__filter-head h4" }
const _hoisted_6 = { class: "showcase-app__filtering-col col-md-6 col-lg-5" }
const _hoisted_7 = { class: "showcase-app__filtering-col col-md-6 col-lg-5" }
const _hoisted_8 = { class: "showcase-app__container" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  class: "showcase-app__list"
}
const _hoisted_11 = {
  key: 0,
  class: "text-center section-small-md-up"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "load-indicator__indicator" }, null, -1 /* HOISTED */)
const _hoisted_13 = { class: "load-indicator__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ShowcaseFilter = _resolveComponent("ShowcaseFilter")!
  const _component_ShowcaseCard = _resolveComponent("ShowcaseCard")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString($data.translations?.FilterBy), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_ShowcaseFilter, {
              filter: "Portfolio",
              filterOptions: $data.showcaseFilterPortfolioData,
              onFilterChange: $options.filterChange
            }, {
              filterTitle: _withCtx(() => [
                _createTextVNode(_toDisplayString($data.translations?.Portfolio), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["filterOptions", "onFilterChange"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_ShowcaseFilter, {
              filter: "ShowcaseStyle",
              filterOptions: $data.showcaseFilterStyleData,
              onFilterChange: $options.filterChange
            }, {
              filterTitle: _withCtx(() => [
                _createTextVNode(_toDisplayString($data.translations?.Style), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["filterOptions", "onFilterChange"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      ($data.showcases && $data.showcases.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString($data.translations?.NoMatchingShowcases), 1 /* TEXT */))
        : (_openBlock(), _createElementBlock("ul", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.showcases, (showcase, index) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "showcase-app__item",
                key: index
              }, [
                _createVNode(_component_ShowcaseCard, {
                  credits: showcase.Credits,
                  url: showcase.UrlName,
                  index: index,
                  styleValue: showcase.ShowcaseStyle.PersistedValue,
                  styleName: showcase.ShowcaseStyle.Text,
                  portfolio: showcase.Portfolio.PersistedValue,
                  portfolioName: showcase.Portfolio.Text,
                  title: showcase.Title,
                  image: showcase.Image,
                  imageAltText: showcase.ImageAltText
                }, null, 8 /* PROPS */, ["credits", "url", "index", "styleValue", "styleName", "portfolio", "portfolioName", "title", "image", "imageAltText"])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
    ]),
    ($data.buttonEnabled === true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.showAllTrigger && $options.showAllTrigger(...args))),
            class: "btn btn-primary btn-lg"
          }, _toDisplayString($data.translations?.ShowMore), 1 /* TEXT */)
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      class: _normalizeClass(["load-indicator", { 'state-visible': $data.loadingResults === true }])
    }, [
      _hoisted_12,
      _createElementVNode("span", _hoisted_13, _toDisplayString($data.translations?.Loading), 1 /* TEXT */)
    ], 2 /* CLASS */),
    _createElementVNode("div", {
      class: _normalizeClass(["load-indicator-cover", { 'state-visible': $data.loadingResults === true }])
    }, null, 2 /* CLASS */)
  ]))
}